import React, { useState } from 'react';
import Loading from '../../../../Components/Loading';
import useRootWorkplace from '../../../Manager/Hooks/useRootWorkplace';
import Text from '../../../../Components/Base/Text/Text';
import InsuranceRow from './Insurance/InsuranceRow/InsuranceRow';
import apiClient from '../../../../Services/ApiClient';
import { useAppContext } from '../../../../Services/AppContext';
import {
	useLazyMetaQuery,
	useTermItemsQuery,
} from '../../../../graphql/graphql';
import {
	InsuranceSettings,
	WorkplaceInsuranceSettings,
} from '../../Interfaces/insuranceSettings';
import { useEffectAsync } from '../../../../helpers';

// @ts-ignore
import styles from './NcziManager.module.scss';

const NcziManager: React.FC = () => {
	const { workplaceId, userData } = useAppContext();
	const { rootWorkplaceId } = useRootWorkplace(workplaceId, userData.id);
	const { data, isLoading } = useTermItemsQuery({
		termType: 'insurance_companies',
	});
	const [getMeta] = useLazyMetaQuery();
	const [settings, setSettings] = useState<WorkplaceInsuranceSettings>({});

	const handleSaveInsurance = async (
		insuranceKey: string,
		data: InsuranceSettings,
	) => {
		const tmpSettings = { ...settings };
		tmpSettings[insuranceKey] = data;
		setSettings(tmpSettings);

		const { meta } = await getMeta({
			key: 'nczi',
			workplaceId: rootWorkplaceId,
		}).unwrap();

		await apiClient.post(`/workplaces/${rootWorkplaceId}/meta/`, {
			key: 'nczi',
			value: meta?.value
				? { ...meta.value, insurance: tmpSettings }
				: { insurance: tmpSettings },
			rootWorkplaceId,
		});
	};

	useEffectAsync(async () => {
		if (rootWorkplaceId) {
			const { meta } = await getMeta({
				key: 'nczi',
				workplaceId: rootWorkplaceId,
			}).unwrap();

			if (meta?.value) {
				setSettings(meta.value.insurance || {});
			}
		}
	}, [rootWorkplaceId]);

	if (isLoading || !rootWorkplaceId) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text tx='component.nczi.setup.insuranceCommunicationSetup' />
			{data?.termItems?.data?.map(item => (
				<InsuranceRow
					key={item.id}
					insuranceCompany={item}
					settings={settings[item.value3]}
					saveInsuranceSettings={values =>
						handleSaveInsurance(item.value3, values)
					}
				/>
			))}
		</div>
	);
};

export default NcziManager;
